<template>
    <ModalCustom
        :is-open="true"
        @close="$emit('close')"
        title="Select Videos"
        z-index="1001"
    >
        <div class="w-[80vw] max-h-[70vh] overflow-y-auto p-4">
            <div class="flex flex-wrap gap-2 mb-4">
                <div
                    v-for="selectedVideo in selectedVideos"
                    :key="selectedVideo.id"
                    class="
                        flex
                        items-center
                        rounded-md
                        px-2
                        py-1
                        text-sm
                        font-medium
                        ring-1 ring-inset ring-green-700/10
                        text-green-700
                        bg-green-50
                        gap-1
                    "
                >
                    <span>{{ selectedVideo.title }}</span>
                    <ion-icon
                        name="close-outline"
                        class="cursor-pointer"
                        @click="toggleSelect(selectedVideo)"
                    ></ion-icon>
                </div>
            </div>

            <div v-if="isLoading" class="flex justify-center p-12">
                <loading-circle />
            </div>

            <div v-else class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div
                    v-for="video in videos"
                    :key="video.id"
                    @click="toggleSelect(video)"
                    class="
                        border-2
                        rounded-lg
                        p-2
                        cursor-pointer
                        hover:border-primary
                        transition-colors
                    "
                    :class="
                        isSelected(video)
                            ? 'border-primary bg-green-50'
                            : 'border-gray-200'
                    "
                >
                    <div
                        class="
                            aspect-video
                            bg-black
                            rounded
                            mb-2
                            overflow-hidden
                            flex
                            items-center
                            justify-center
                        "
                    >
                        <img
                            v-if="video.thumbnail"
                            :src="video.thumbnail"
                            class="w-full h-full object-cover"
                        />
                        <ion-icon
                            v-else
                            name="videocam"
                            class="text-white text-3xl"
                        ></ion-icon>
                    </div>
                    <div class="text-xs font-bold text-center truncate">
                        {{ video.title }}
                    </div>
                </div>
            </div>

            <div
                v-if="!isLoading && videos.length === 0"
                class="text-center p-12 text-gray-500"
            >
                No videos found for this team
            </div>

            <div class="mt-6 flex justify-end gap-2 border-t pt-4">
                <button
                    @click="$emit('close')"
                    class="
                        px-4
                        py-2
                        text-sm
                        font-medium
                        text-gray-700
                        hover:bg-gray-100
                        rounded-md
                    "
                >
                    Cancel
                </button>
                <button
                    @click="confirm"
                    class="
                        px-4
                        py-2
                        text-sm
                        font-medium
                        text-white
                        bg-primary
                        hover:bg-primary-dark
                        rounded-md
                    "
                >
                    Confirm Selection
                </button>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import ModalCustom from "../ModalCustom.vue";
import LoadingCircle from "../LoadingCircle.vue";

const props = defineProps({
    videoApi: String,
    initialSelected: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(["close", "selected"]);

const isLoading = ref(true);
const videos = ref([]);
const selectedVideos = ref([...props.initialSelected]);

const isSelected = (video) => {
    return selectedVideos.value.some((v) => v.id === video.id);
};

const toggleSelect = (video) => {
    if (isSelected(video)) {
        selectedVideos.value = selectedVideos.value.filter(
            (v) => v.id !== video.id
        );
    } else {
        selectedVideos.value.push(video);
    }
};

const confirm = () => {
    emit("selected", [...selectedVideos.value]);
    emit("close");
};

onMounted(async () => {
    const teamId = new URLSearchParams(window.location.search).get("teamId");
    try {
        const response = await axios.get(props.videoApi, {
            params: { teamId },
        });
        videos.value = response.data;
    } catch (error) {
        console.error("Failed to load videos", error);
    } finally {
        isLoading.value = false;
    }
});
</script>
